module.exports = "/images/cm.svg?7d38a2744ad642c87b4b221edfc06d05";